<main *ngIf="permissionDenied===false" @fade>
  <nb-card [nbSpinner]="loading">
    <nb-card-header *ngIf="!isModal && !editMode" i18n="@@Creating"><a [routerLink]="absolutePath">{{ title }}</a> / Добавление</nb-card-header>
    <nb-card-header *ngIf="!isModal && editMode" i18n="@@Updating"><a [routerLink]="absolutePath">{{ title }}</a>
      <span *ngIf="editName">  / {{ editName }}  </span>
    </nb-card-header>

    <nb-card-header *ngIf="deleted"><span class="badge text-bg-secondary" i18n="@@RecordDeletedNoTags">запись удалена</span>
      &nbsp;
      <button (click)="restore()" *ngIf="deleted" i18n-nbTooltip="@@Restore" nbButton nbTooltip="Восстановить" size="small" status="control">
        <nb-icon icon="repeat-outline"/>
      </button>
    </nb-card-header>

    <nb-card-body>
      <div [ngClass]="isModal ? '' : 'row'">
        <div [ngClass]="isModal ? '' : 'col-lg-7 n-part-left'">
          <app-create-update-form [base]="this"/>
        </div>
        <div *ngIf="editMode" class="col-lg-4 n-part-left">
          <app-picture (pictureEvent)="pictureEvent($event)" [entityModel]="model" [pictureField]="pictureField" [uri]="uploadPictureUri">
            <span *ngIf="pictureInfo" i18n="@@BannerPictureInfo">{{ pictureInfo }}</span>
          </app-picture>

          <app-terms (insertTermEvent)="insertTerm($event)" (removeTermEvent)="removeTerm($event)" [model]="model"/>

          <div *ngIf="damRelatedSystemTag | async as systemTag; else buttonTpl">
            
            <p> Системный маркер:<br>
            <a [routerLink]="['/cabinet/pim/system-tags/edit', systemTag.id]">
                  {{ systemTag.header }}
            </a>
          </p>

          </div>

          <ng-template #buttonTpl>
            <button nbButton  status="primary" i18n="@@ChooseCategoryButton" (click)="createSystemTag()"> Создать системный маркер </button>
          </ng-template>

          
        </div>
      </div>
    </nb-card-body>

  </nb-card>
</main>
<main *ngIf="permissionDenied">
  Permission Denied
</main>
